export default "__VITE_ASSET__BwDOf_As__"